import React from 'react';
import { View, Text, Pressable } from 'react-native';
import i18n from 'i18next';
import { Organization, Topic } from '../../client/interfaces';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import DropdownCheckbox from '../DropdownCheckbox';

interface Props {
  title: string;
  name: string;
  inputValue: string;
  onChangeText: (text: string) => void;
  selectedItem: Topic | Organization | undefined;
  filteredContent: (Topic | Organization)[];
  onSelect: (item: Topic | Organization) => void;
  helperText: string;
  onNavigateToCreate: () => void;
  zIndex?: number;
  errorMessage?: string;
}

const DropdownWithLink: React.FC<Props> = ({
  title,
  name,
  inputValue,
  onChangeText,
  selectedItem,
  filteredContent,
  onSelect,
  helperText,
  onNavigateToCreate,
  zIndex = 30,
  errorMessage,
}) => {
  const { t } = useAppTranslation();

  return (
    <View className="mb-11" style={{ zIndex }}>
      <DropdownCheckbox
        onChangeText={onChangeText}
        inputValue={inputValue}
        placeholder={t('admin:helpdesk_issue_edit:choose_an_option')}
        selectedItem={selectedItem}
        filteredContent={filteredContent}
        itemOnPress={onSelect}
        singleSelect
        title={title}
        required
        name={name}
        errorMessage={errorMessage}
      />
      <View className="flex-row gap-x-1 flex-wrap">
        <Text className="text-notificationMessage text-neutral-950 dark:text-neutral-50 font-[sans-600] mt-[6px] whitespace-nowrap">
          {helperText}
        </Text>
        <Pressable onPress={onNavigateToCreate}>
          <Text className="text-notificationMessage text-neutral-950 dark:text-neutral-50 font-[sans-600] mt-[6px] underline whitespace-nowrap">
            {t('admin:helpdesk_issue_edit:this_platform')}
          </Text>
        </Pressable>
        {i18n.language === 'hu' && (
          <Text className="text-notificationMessage text-neutral-950 dark:text-neutral-50 font-[sans-600] mt-[6px] whitespace-nowrap">
            {t('admin:helpdesk_issue_edit:can_add')}
          </Text>
        )}
      </View>
    </View>
  );
};

export default DropdownWithLink;
